import { SELECT_EMAIL_CRM_OBJECT } from 'email-management-lib/refactor/actions/actionTypes';
const initialState = null;
export default function selectedEmailCrmObject(state = initialState, action) {
  switch (action.type) {
    case SELECT_EMAIL_CRM_OBJECT:
      return action.payload.crmObject;
    default:
      return state;
  }
}